export default __webpack_public_path__ + "static/media/billing.068d596d.svg";